import { z } from 'zod';
import { withSortableParams } from '../../helpers';
import { CalendarDay } from '../../../utils';
import {
  AccountingReportDateOption,
  TrialBalanceGroupByOption,
  IncomeStatementDateOption,
} from 'further-types/lp/general-ledger';

const TransactionDateRangeInput = z.object({
  startDate: z.instanceof(CalendarDay).optional(),
  endDate: z.instanceof(CalendarDay),
});

export const ListTransactionsInput = withSortableParams(
  TransactionDateRangeInput.extend({
    searchQuery: z.string().optional(),
  }),
  [
    'accountLabel',
    'accountSection',
    'transactionType',
    'transactionDate',
    'vatRate',
    'amountIncVatLcy',
    'amountIncVatTcy',
    'transactionCurrency',
    'description',
    'counterpartyLabel',
    'counterpartyRef',
    'createdByLabel',
    'bankAccountLabel',
  ],
);

export const ExportTransactionListInput = TransactionDateRangeInput.extend({
  searchQuery: z.string().optional(),
});

export const TrialBalanceInput = z.object({
  vehicleId: z.string(),
  dateOption: z.nativeEnum(AccountingReportDateOption),
  customDate: z.instanceof(CalendarDay).optional(),
  groupBy: z.nativeEnum(TrialBalanceGroupByOption),
});

export const IncomeStatementInput = z.object({
  vehicleId: z.string(),
  dateOption: z.nativeEnum(IncomeStatementDateOption),
  customDateRange: z
    .object({
      startDate: z.instanceof(CalendarDay),
      endDate: z.instanceof(CalendarDay),
    })
    .optional(),
});

export const CashFlowStatementInput = z.object({
  vehicleId: z.string(),
  dateOption: z.nativeEnum(IncomeStatementDateOption),
  customDateRange: z
    .object({
      startDate: z.instanceof(CalendarDay),
      endDate: z.instanceof(CalendarDay),
    })
    .optional(),
});

export const ScheduleOfInvestmentsInput = z.object({
  vehicleId: z.string(),
  dateOption: z.nativeEnum(AccountingReportDateOption),
  customDate: z.instanceof(CalendarDay).optional(),
});
